const Update = () => {
  return (
    <div className="page update">
      <h2>Update</h2>
    </div>
  )
}

export default Update